import { Form } from 'react-router';
import { Button } from '@/components/ui/button';
import { Building2 } from 'lucide-react';

interface EnterpriseLoginButtonProps {
    providerLabel?: string;
    redirectPath?: string | null;
}

export function EnterpriseLoginButton({ providerLabel = 'Enterprise', redirectPath }: EnterpriseLoginButtonProps) {
    return (
        <Form method="post" className="w-full">
            <input type="hidden" name="loginMode" value="enterprise" />
            {redirectPath && <input type="hidden" name="redirectPath" value={redirectPath} />}
            <Button type="submit" className="flex w-full items-center gap-2" size="lg">
                <Building2 className="size-4 shrink-0" aria-hidden="true" />
                <span>Sign in with {providerLabel}</span>
            </Button>
        </Form>
    );
}
